exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-popup-container {\r\n    background: #F0F0F0;\r\n    padding-top: 20px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inventory/cycle-count/stock-take-parameters/cycle-count-home/cycle-count-details/cc-search-popup/cc-search-popup.component.css
// module id = ../../../../../src/app/features/inventory/cycle-count/stock-take-parameters/cycle-count-home/cycle-count-details/cc-search-popup/cc-search-popup.component.css
// module chunks = main